import { AppShellTrigger, Box, Text, useIsMobile } from "@salestrak/ui";
import * as React from "react";

export const SettingsMobileHeaderContext = React.createContext(false);

/**
 * Mobile-only settings top bar: the nav-drawer trigger beside the section's
 * name, the same [trigger] [title] line every other compact page header
 * draws. The trigger opens the drawer on the settings pane, and that pane's
 * own arrow is the way back to the app — the bar used to carry a second
 * "‹ Settings" button for that, and two controls that both summoned the
 * drawer read as a doubled menu button. Paints the page surface
 * (`background`) with a bottom border, so it reads as the page's own top
 * edge rather than a tinted navigation strip.
 */
export function SettingsMobileHeader() {
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  return (
    <Box
      align="center"
      background="background"
      border="bottom"
      direction="row"
      gap="sm"
      paddingX="md"
      paddingY="sm"
    >
      <AppShellTrigger />
      {/* Full ink: the label is the pane title, so it rests at full ink. */}
      <Text size="base" weight="semibold">
        Settings
      </Text>
    </Box>
  );
}
